import { useTranslation } from 'libs/i18n';
import { IconButton, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

interface Props {
  index: number;
  readOnly?: boolean;
  onRemove: (index: number) => void;
}

export const Header = ({ index, readOnly, onRemove }: Props) => {
  const { t } = useTranslation();
  const isFirst = index === 0;
  return (
    <Stack alignItems="center" direction="row" spacing={12}>
      <Typography variant="bodyBold">
        {t(
          isFirst
            ? 'client.legal.companyLicense.licenseTitle'
            : 'client.legal.companyLicense.licenseOtherTitle'
        )}
      </Typography>
      {!readOnly && !isFirst && (
        <IconButton
          colorVariant="red"
          icon={<Icon.Minus size={16} />}
          mode="outlined"
          sizeVariant="xs"
          onClick={() => onRemove(index)}
        />
      )}
    </Stack>
  );
};
